// extracted by mini-css-extract-plugin
module.exports = {"title":"Y_SxCRwQ","desc":"NitWpjAR","footer":"Bo_Ch9_8","blueColor":"rofP3ev4"};